import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Link } from 'react-router'
import classnames from 'classnames'
import { isPremium } from '../../../utils/plans'

import BillingStore from '../../../stores/billing'

@observer
class BillingUpgrade extends Component {
  state = {
    store: new BillingStore()
  }

  componentWillMount() {
    this.state.store.loadLicense()
  }

  handleUpgrade = event => {
    event.preventDefault()

    this.setState({ upgrading: true })
    this.state.store.doUpgrade().then(
      () => this.setState({ upgrading: false, upgraded: true })
    )
  }

  currentPremiumPlanOffering() {
    const { store: { license } } = this.state

    return `premium_${license.rate}_APR26`

  }

  render() {
    const { store: { license }, upgrading, upgraded } = this.state

    if (!license) return <div className="loading">Loading...</div>

    if (upgrading) return (
      <div className="container centered padded upgrade">
        <div className="panel full padded upgrades">
          <div className="loading">Upgrading...</div>
        </div>
      </div>
    )

    if (upgraded) return (
      <div className="container centered padded upgrade">
        <div className="panel full padded upgrades">
          <h1 className="title">Thanks for upgrading!</h1>
          <p>All your websites now have access to the full set of Premium features!</p>
          <p>The difference in cost will be prorated on your next bill.</p>

          <Link to="/billing">Back to Billing</Link>
        </div>
      </div>
    )

    const users = license.additional_user_count
    const fullPlanName = license.full_plan_name
    const currentPlan = license.invoice_breakdown.items.find(
        item => item.plan === fullPlanName
    )
    const premiumPlanName = this.currentPremiumPlanOffering()
    const premiumPlan = license.invoice_breakdown.rates.find(
        item => item.plan === premiumPlanName
    )

    return (
      <div className="container centered padded upgrade">
        <div className="panel full padded upgrades">
          <h2 className="title">Change Plan</h2>

          <div className="plans">
            {!isPremium(license.plan) &&
            <div className="plan current">
              <h3 className="current">Current Plan</h3>
              <h1>Essentials</h1>
              <h2>${currentPlan.cost}</h2>
              <p className="sub">{license.rate}</p>

              <hr/>

              <div className="feature">Powerful IDX search engine</div>
              <div className="feature">Fully-indexable, SEO optimized</div>
              <div className="feature">Search parties & social search features</div>
              <div className="feature">Branded & configurable emails</div>
              <div className="feature">MLS data updated every 10 minutes</div>
            </div>}

            <div className={classnames('plan', { current: isPremium(license.plan) })}>
              <h3 className="current">Current Plan</h3>
              <h1>Premium</h1>
              <h2>${premiumPlan ? premiumPlan.cost : 0}</h2>
              <p className="sub">{license.rate}</p>

              <hr/>

              <div className="feature">Everything in the Essentials plan, plus:</div>
              <div className="feature">Premium listing detail page content</div>
              <div className="feature">Additional search customization</div>
              <div className="feature">Advanced registration controls</div>
              <div className="feature">Get new features first</div>

              <a href="#" className="button" onClick={this.handleUpgrade}>Upgrade to Premium</a>

              {license.additional_website_count > 0 && license.additional_user_count > 0 && <hr/>}

              {license.additional_website_count > 0 &&
                <p className="sub">
                  You have {license.additional_website_count} additional websites that will now be billed at ${license.additional_website_count > 10 ? 50 : 55}/mo.
                </p>}
              {users > 0 &&
                <p className="sub">
                  You have {users} additional users.
                  {users < 4 && 'They will now be included in the month price. '}
                  {3   < users && users < 9   && ` You have ${users - 3} additional users that will now be billed at $4/mo.`}
                  {8   < users && users < 49  && ` You have ${users - 3} additional users that will now be billed at $3/mo.`}
                  {48  < users && users < 99  && ` You have ${users - 3} additional users that will now be billed at $2.50/mo.`}
                  {98  < users && users < 199 && ` You have ${users - 3} additional users that will now be billed at $2.25/mo.`}
                  {198 < users                && ` You have ${users - 3} additional users that will now be billed at $2/mo.`}
                </p>}
            </div>

            {isPremium(license.plan) && <div className="downgrade">Need to downgrade? <a href="mailto:help@showcaseidx.com">Contact support.</a></div>}
          </div>
        </div>
      </div>
    )
  }
}

export default BillingUpgrade



// WEBPACK FOOTER //
// client/components/sections/Billing/Upgrade.js